import FilterWrapper from 'components/Embeds/FilterWrapper';

const EmbedSearchFilter = ({ label, lang, value, onChange, debounce = 750 }) => (
  <FilterWrapper
    label={label}
    type="input"
    value={value}
    onChange={onChange}
    allowAll={true}
    lang={lang}
    debounce={debounce}
  />
);

export default EmbedSearchFilter;


